import {AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {CodaltComponent} from '../codalt/codalt.component';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {UserDataSource} from './user-data-source.service';
import {fromEvent} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {debounce} from '../../utils.class';
import {UserService} from '../../services/user.service';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {User} from '../../classes/user';
import {Title} from '@angular/platform-browser';
import {Role} from '../../classes/role.class';
import {AuthorisationService} from '../../services/auth/authorisation.service';
import {FormControl} from '@angular/forms';


@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss']
})
export class UsersComponent extends CodaltComponent implements OnInit, AfterViewInit {

    users: User[];
    displayedColumns: string[] = ['created_at', 'name', 'email', 'editUser', 'deleteUser'];
    dataSource: UserDataSource;
    availableRoles: Role[] = [];
    roleFilterControl = new FormControl<string[]>([]);
    readonly withoutRolesKey = 'none';
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;

    constructor(private userService: UserService,
                private confirmDialogService: ConfirmDialogService,
                private authorisationService: AuthorisationService,
                private title: Title) {
        super();
    }

    @HostListener('window:resize', ['$event'])
    @debounce()
    calculatePageSize() {
        const pageSize = Math.max(Math.floor((window?.innerHeight - 180) / 48), 3);
        if (this.paginator) {
            this.paginator.pageSize = pageSize;
            this.paginator._changePageSize(pageSize);
        }
    }

    ngOnInit() {
        this.title.setTitle('Gebruikersbeheer - TSNed App');
        this.dataSource = new UserDataSource(this.userService);

        this.subscriptions.add(this.authorisationService.getRoles().subscribe(roles => {
            this.availableRoles = roles;

            const selectedRoles = [...roles.filter(r => r.key !== 'customer').map(r => r.key), this.withoutRolesKey];
            this.roleFilterControl.setValue(selectedRoles, {emitEvent: false});
            this.dataSource.roles = selectedRoles.join(',');
        }));

        this.subscriptions.add(this.roleFilterControl.valueChanges.subscribe(roleKeys => {
            this.paginator?.firstPage();
            this.dataSource.roles = roleKeys?.length ? roleKeys.join(',') : '';
        }));
    }

    delete(user: User) {
        this.confirmDialogService.confirm(
            'Verwijderen bevestigen',
            'Weet u zeker dat u ' + (user.name || user.email) + ' wilt verwijderen?',
            'Verwijderen',
            'Behouden').then(() => {
            this.userService.deleteUser(user.id).subscribe(() => {
                this.dataSource.loadUsers();
            });
        }, () => {
            console.log(user);
        });
    }

    ngAfterViewInit() {
        this.calculatePageSize();
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        fromEvent<KeyboardEvent>(this.searchInput.nativeElement, 'keyup')
            .pipe(debounceTime(300)).subscribe(() => {
            this.paginator.firstPage();
            this.dataSource.searchString = this.searchInput.nativeElement.value;
        });
    }

}
